import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { base_url } from '../Api/Api';
import { Scrollbar } from "react-scrollbars-custom";

import MyScore from './Scores';
import Ticket from './Ticket';
import Courses from './Courses';
import SkltnTicketItem from './Tickets/skltn/sklnTicketItem';
import ItemCourseSkltn from './MyCourses/ItemCourseSkltn';
import Cookies from 'universal-cookie';

const Profile = (props) => {

    const [state, setState] = useState({
        progress: 0,
        courses: [],
        statusCourse: false,
        ticket: [],
        statusTickt: false,
        score: [],
        stores:[]
    })
    const [progress, setProgress] = useState(0);
    const cookies = new Cookies()
    
    useEffect(() => {

        window.scrollTo(0, 0)
        if (cookies.get("api_key") == null) {
            props.history.push(`/Entrance`)
        }


        base_url.get(`panel_stat`)
            .then(response => {
                let dataScore = {
                    minusScores: response.data.minusScores,
                    plusScores: response.data.plusScores,
                }
                setState({
                    ...state,
                    score: dataScore,
                    ticket: response.data.tickets,
                    courses: response.data.courses,
                    statusTickt: response.data.tickets.length == 0,
                    statusCourse: response.data.courses.length == 0,
                    stores:response.data.stores,

                })
                setProgress((response.data.totalScores * 100) / response.data.max_score);
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="profile">
            <div className="contain">
                <div className="first_section">
                    <div className="Scores">
                        <div className="title">
                            <span>امتیازات من</span>
                        </div>
                        <div className="MyScores">
                            <MyScore
                                progress={progress}
                                data={state.score} />
                        </div>
                    </div>
                    <div className="Tickets">
                        <div className="titles">
                            <span>تیکت های من</span>
                            <Link to="/Tickets">موارد بیشتر <i className="icon-arrow-down-sign-to-navigate-fill"></i> </Link>
                        </div>
                        <div className="MyTickets">
                            {state.ticket.length == 0 ?
                                state.statusTickt ?
                                    <span className="no-content">
                                        <i className="icon-comment"></i>
                                        تیکتی ثبت نشده
                                    </span>
                                    :
                                    <div className="skltn-ticket">
                                        <SkltnTicketItem />
                                    </div>
                                :
                                <Scrollbar
                                    style={{ width: 100 + '%', height: 100 + '%' }}>
                                    {state.ticket.slice(0, 10).reverse().map(item =>
                                        <Ticket
                                            key={item.id}
                                            id={item.id}
                                            status={item.status}
                                            statusMessage={item.status_message}
                                            recivierRead={item.recivier_read}
                                            title={item.title}
                                            date={item.jdate}
                                            number={item.id}
                                        />
                                    )}
                                </Scrollbar>
                            }
                        </div>
                    </div>
                </div>
                <div className="crses">
                    <div className="titles">
                        <span>کورس های من</span>
                        <Link to="/MyCourses">موارد بیشتر <i className="icon-arrow-down-sign-to-navigate-fill"></i> </Link>
                    </div>
                    <div className="MyCourse">
                        {state.courses.length == 0 ?
                            state.statusTickt ?
                                <span className="no-content">
                                    <i className="icon-mortarboard"></i>
                                    کورسی وجود ندارد
                                    </span>
                                :
                                <ItemCourseSkltn
                                    count={3} />
                            :
                            state.courses.slice(0, 3).map(course =>
                                <Courses
                                    data={course} />
                            )}
                    </div>
                </div>

                <div className="others">
                    <div className="lisence">
                        <h4>گواهینامه های من</h4>
                        <div className="certificate">
                            <i className="icon-certificate"></i>
                        </div>
                        <div className="seemore">
                            <Link to="/Licence">مشاهده همه <i className="icon-arrow-down-sign-to-navigate-fill"></i> </Link>
                        </div>
                    </div>
                    <div className="lisence">
                        <h4>قرعه کشی های من</h4>
                        <div className="lottery">
                            <i className="icon-present-box-1"></i>
                        </div>
                        <div className="seemore">
                            <Link to="/Lottery">مشاهده همه<i className="icon-arrow-down-sign-to-navigate-fill"></i> </Link>
                        </div>
                    </div>
                    <div className="lisence">
                        <h4>فروشگاه من</h4>
                        <div className="lottery">
                            <i className="icon-present-box-1"></i>
                        </div>
                        <div className="seemore">
                           <span> {state.stores.length ? state.stores[0].name : null}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
}

export default Profile;